import { FC } from 'react';
import {
  Create,
  Edit,
  SimpleForm,
  TextInput,
  BooleanInput,
  DateTimeInput,
  required,
} from 'react-admin';

const transformData = (data: any) => {
  return data;
};

export const TrendCreate = (props: any) => (
  <Create {...props} transform={transformData}>
    <SimpleForm>
      <TextInput
        source="name"
        label="Название"
        fullWidth
        validate={required()}
      />
      <TextInput
        source="description"
        fullWidth
        minRows={3}
        maxRows={10}
        label="Текст перед тестом"
        multiline
      />
      <BooleanInput source="is_published" label="Опубликовано" fullWidth />
      <DateTimeInput source="published_at" label="Дата публикации" fullWidth />
      <TextInput
        source="link"
        label="Ссылка на материал"
        fullWidth
        validate={required()}
      />
      <TextInput
        source="img"
        label="Ссылка на картинку"
        fullWidth
        validate={required()}
      />
    </SimpleForm>
  </Create>
);
